import { Controller, useFormContext } from 'react-hook-form';
import { Select, SelectProps } from 'antd';
import { useState } from 'react';
import generateKey from '../../utils/generateKey';

interface FormSelectProps extends SelectProps {
  name: string;
  children: React.ReactNode;
}

export const FormSelect = ({
  name,
  children,

  ...props
}: FormSelectProps) => {
  const { control } = useFormContext();
  const [key, setKey] = useState('');

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Select
          key={key}
          onChange={onChange}
          onClear={() => onChange('')}
          onBlur={() => setKey(generateKey())}
          value={value}
          defaultActiveFirstOption={true}
          {...props}
        >
          {children}
        </Select>
      )}
    />
  );
};
